export default (() => {

  $('[data-youtube]').each(function() {

    var videoSRCauto = $(this).data('youtube');

    $(this).on('click', function() {
      $($(this).data('target')).find('iframe').attr('src', videoSRCauto);
    });

    $($(this).data('target')).on('hidden.bs.modal', function (event) {
      $(this).find('iframe').attr('src', '');
    });
  });

})();
